module.exports = __webpack_public_path__ + "static/media/redux-woods.dfcc8ddc.jpg";